import { RefreshAsync } from '@/services/AuthenticationService.js';
import LoginStatusType from '@/objects/LoginStatusType.js';
import store from '@/store';
import router from '@/router';

const limit = 10;

async function RefreshCallback(status, axios, refreshCount, newConfig) {
  const { code } = status || {};
  if (refreshCount >= limit) {
    // 重複取得 refreshToken 超過上限
    if (router.history.current.name !== 'Logout') {
      router.push({ name: 'Logout', query: { redirect: router.history.current.path || '' } });
    }
    return new Promise((resolve, reject) => reject(new Error('fail')));
  }

  if (newConfig.retryCount >= limit) {
    // 超出重試上限強制登出
    if (router.history.current.name !== 'Logout') {
      router.push({ name: 'Logout', query: { redirect: router.history.current.path || '' } });
    }
  }

  if (code === LoginStatusType.Success.code) {
    // 成功取得新 access token
    const waitTime = (newConfig.retryCount || 0) ** 2 * 100;
    return new Promise((resolve, reject) => {
      // 指數式重試
      setTimeout(() => {
        axios.request(newConfig).then((response) => {
          resolve(response);
        }).catch((err) => {
          reject(err);
        });
      }, waitTime);
    });
  }

  const retryRefershhCount = refreshCount + 1;

  return RefreshAsync().then((res) => RefreshCallback(res, axios, retryRefershhCount, newConfig));
}

export function UseUnauthorizedProcess(axios) {
  axios.interceptors.response.use((response) => response, (error) => {
    const resp = error.response;
    if (resp.status === 401) {
      const newConfig = { ...error.config };
      const count = newConfig.retryCount || 0;
      newConfig.retryCount = count + 1;
      return RefreshAsync().then((status) => RefreshCallback(status, axios, 1, newConfig));
    }

    throw error;
  });
}

// export function UseUnauthorizedProcess(axios) {
//   axios.interceptors.response.use((response) => response, (error) => {
//     const resp = error.response;
//     if (resp.status === 401) {
//       const newConfig = { ...error.config };
//       const count = newConfig.retryCount || 0;
//       newConfig.retryCount = count + 1;
//       return RefreshAsync().then((status) => {
//         const { code } = status || {};
//         if (newConfig.retryCount >= limit) {
//           // 超出重試上限強制登出
//           if (router.history.current.name !== 'Logout') {
//             router.push({ name: 'Logout', query: { redirect: router.history.current.path || '' } });
//           }
//         } else {
//           // eslint-disable-next-line no-lonely-if
//           if (code === LoginStatusType.Success.code) {
//             // 成功取得新 access token
//             const waitTime = count ** 2 * 100;
//             return new Promise((resolve, reject) => {
//               // 指數式重試
//               setTimeout(() => {
//                 axios.request(newConfig).then((response) => {
//                   resolve(response);
//                 }).catch((err) => {
//                   reject(err);
//                 });
//               }, waitTime);
//             });
//           }
//           if (router.history.current.name !== 'Login') {
//             router.push({ name: 'Login', query: { redirect: router.history.current.path || '' } });
//           }
//         }

//         throw error;
//       });
//     }

//     throw error;
//   });
// }

export function UseAddAuthenticationProcess(axios) {
  axios.interceptors.request.use((config) => {
    const { accessToken, company } = store.getters;
    // eslint-disable-next-line no-param-reassign
    config.headers = Object.assign(config.headers, {
      Authorization: `Bearer ${accessToken}`,
      'X-Company': company
    });

    return config;
  });
}
